// extracted by mini-css-extract-plugin
export default {"questionWrapper":"questionWrapper-MgWYw","exampleBtn":"exampleBtn-szWr5","active":"active-sXyEq","audio":"audio-aDYwT","back":"back-JMxsk"};